<template>
  <!-- 테스트 : /test/IInputSelTest -->
  <v-select

    v-bind="{
      ...$attrs,
      items: items_cp,
      value,
      itemValue
    }"

    v-on="{
      ...$listeners
    }"

    outlined
    dense

    class="imd-sm-input imd-sm-select"
    :menu-props="{ offsetY: true, offsetOverflow: true, transition: 'scroll-y-transition' }"

  />
  <!-- auto: true,  -->
</template>

<style>
/* div.imd-app > div.v-menu__content > div.v-select-list > div.v-list > div.v-list-item > div.v-list-item__content > div.v-list-item__title { color : red; } */

/* div.imd-app > div.v-menu__content.theme--light.menuable__content__active > div.v-select-list { margin-top: 23px; } */
/* div.imd-app > div.v-menu__content > div.v-select-list > div.v-list > div.v-list-item { margin-top:0; margin-bottom:0; padding:3px 1px 3px 3px; min-height: unset;} */
/* div.imd-app > div.v-menu__content > div.v-select-list > div.v-list > div.v-list-item > div.v-list-item__content { margin-top:0; margin-bottom:0; padding:0px 1px 0 3px} */

/* div.imd-app > div.v-menu__content.theme--light.menuable__content__active > div.v-select-list { margin-top:0px; padding: 0; border: 1px solid green; } */
/* div.imd-app > div.v-menu__content.theme--light.menuable__content__active > div.v-select-list > div.v-list v-sheet v-sheet--tile theme--light v-list--dense { margin-top:0px; padding: 0; border: 1px solid green; } */

/* 높이 제안 없애기 : 기본값 300px */
/* div.imd-app > div.v-menu__content.theme--light.menuable__content__active  { max-height: unset !important;  } */

/* vueitfy 버그 */
/* div.imd-app > div.v-menu__content.theme--light.menuable__content__active  { max-height: 500px !important;  } */

/* div.imd-app > div.v-menu__content.theme--light.menuable__content__active > div.v-select-list { border: 1px solid red; } */
div.imd-app > div.v-menu__content.theme--light.menuable__content__active > div.v-select-list > div.v-list { padding: 2px 0;}
div.imd-app > div.v-menu__content > div.v-select-list > div.v-list > div.v-list-item { padding:1px 1px 3px 1px; min-height: unset; }
div.imd-app > div.v-menu__content > div.v-select-list > div.v-list > div.v-list-item > div.v-list-item__content { padding:0px 1px 0 3px;}
div.imd-app > div.v-menu__content > div.v-select-list > div.v-list > div.v-list-item > div.v-list-item__content > div.v-list-item__title
{ padding:0px 1px 0 3px; font-Family: Gulim, '굴림', dotum,'돋움', AppleGothic, sans-serif; font-size: 12px; -webkit-font-smoothing: antialiased; color: #666666; }

/* .v-select-list */
.imd-sm-select .v-input__slot { margin-bottom: 0px !important;}

.imd-sm-select .v-select__selections,
.imd-sm-select .v-select__selection--comma  { margin-top:0 !important; margin-bottom:0; padding:0px 1px 0 3px !important; font-size:12px; }

/* selectbox disabled */
.imd-sm-input.v-select.v-text-field.v-input--is-disabled input { display: none;}
.imd-sm-select.v-input--is-disabled .v-select__selections {   border: 1px solid #c2c2c2 !important;background: #EFEFEF !important; border-radius: 4px; line-height: 18px; height:22px;  }

/* button disabled */
.imd-sm-btn.v-btn--disabled .v-btn__content{ color:#999 !important;}

</style>

<!--

  itemsp 사용법

  <i-input-sel v-model="search_type" itemsp="all / 전체 | titl / 제목 | cont / 내용 | name / 작성자 | titl_cont / 제목,내용"/>

-->
<script>
const isDebug = false
let _
import InputSet from './mixin/input-set';
export default {
  inheritAttrs: false,
  mixins: [ InputSet ],
  props: {
    value: [String, Number, Object, Array],
    itemsp: String,
    items: Array,
    itemValue: {
        type: String,
        default: "value"
    },
  },
  data () {
    return {
      items_cp : [],
      org_value : null, // 임의로 값 지정시 원래 값을 보관한다.
    }
  },
  watch : {
    value (n,p) {
      isDebug && console.log("[i-input-sel] watch(value) : new =", n, ", prev =",p, ", org_value =", this.org_value)
      if (this.value === undefined) { // clear()시 호출됨.
        this.$emit("input", "")
      }
      this.autoSelectByValue() // 값이 변경된 것도 create() 하고 동급으로 처리한다.
    },
    items (n,p) { // CODE같은 경우 늦게 로딩될때까 있다. 그걸 왓치해서 items_cp 에 반영하자.
      // const n1 = n && n.length || 0
      // const n2 = p && p.length || 0
      // if (n1 == n2) return // 길이 변화 없는건 그냥 안바뀐걸로.

      isDebug && console.log("[i-input-sel] watch(items) : items =", this.items, ", new =", n, ", prev =", p);

      if (this.isEmptyArray(p) && this.isEmptyArray(n)) {
        isDebug && console.log("[i-input-sel] watch(items) : 둘다 빈값. 아무것도 안함")
        return
      }

      this.items_cp = this.items
      this.autoSelectByItems()
    },
  },
  created() {
    _ = this._
    isDebug && console.log("[i-input-sel] created() : this.value = ", this.value)

    // items대신 itemsp 가 지정된 경우
    if (!this.items && this.itemsp) {
      this.items_cp = this.itemsp.trim()
        .split(/\s*\|\s*/)
        .map(i=>{
          const ar = i.trim().split(/\s*\/\s*/);
          return {
            'value': ar[0],
            'text' : ar.length > 1 ? ar[1] : ar[0]
          }
        })
    } else {
      this.items_cp = this.items
    }

    this.autoSelectByValue() // 자동선택 (select box 처럼)

  },
  methods: {
    hasItemsValue(v) { // 지정된 값이 items 에 있나 ?
      const ret = !_.isEmpty(this.items_cp) && this.items_cp.some(item=>item == v || item && item[this.itemValue] == v)
      isDebug && console.log("[i-input-sel] hasItemsValue(v) : v = ", v, ", isFound =", ret);
      return ret
    },
    getFirstValue() { // 목록의 첫번째 아이템 가져오기
      const firstItem = this.items_cp[0]
      isDebug && console.log("[i-input-sel] getFirstValue() : itemValue =", this.itemValue, ", firstItem =", firstItem);
      if (!firstItem) return firstItem // null or undefined
      const v = firstItem[this.itemValue]
      const ret = v !== undefined ? v : firstItem
      isDebug && console.log("[i-input-sel] getFirstValue() : ret =", ret)
      return ret
    },
    isEmptyArray(array) { // 배열이 비어있나 확인한다.
      // isDebug && console.log("[i-input-sel] isEmptyArray() : array=", array)
      if (array != null && array.length > 0)
      // isDebug && console.log("[i-input-sel] isEmptyArray() : length=", array.length)

      if (array == null || array === undefined) return true
      if (array.length == 1 && array[0] === undefined || array[0] == null) return true
      return false
    },
    autoSelectByValue() { // value 변화에 따른 자동선택

      isDebug && console.log("[i-input-sel] autoSelectByValue() : this.value =", this.value, ", items_cp = ", this.items_cp);

      if (this.value === undefined) { // 현재값이 undefined 면 일하지 않는다.
        isDebug && console.log("[i-input-sel] autoSelectByValue() : 현재 value 가 undefined. 그래서 아무것도 안함")
        return
      }

      if (this.isEmptyArray(this.items_cp)) {  // 배열이 없으면 자동선택 자체를 할게 없다.
        isDebug && console.log("[i-input-sel] autoSelectByValue() : items_cp 가 비었음 아무것도 안함")
        return
      }

      if (this.hasItemsValue(this.value)) { // 일반적인 경우..
        isDebug && console.log("[i-input-sel] autoSelectByValue() : 값 있다. 할꺼 없음 ! this.value =", this.value)
        this.org_value = null
        return
      }

      // 목록의 첫번째 값을 자동으로 선택한다.
      const firstValue = this.getFirstValue()
      if (firstValue === undefined || firstValue === null) {
        isDebug && console.log("[i-input-sel] autoSelectByValue() : firstValue =", firstValue, " 아무것도 안함");
        return
      }

      isDebug && console.log("[i-input-sel] autoSelectByValue() : 원본 값 보관 : org_value =", this.org_value)

      isDebug && console.log("[i-input-sel] autoSelectByValue() : firstValue =", firstValue, " EMIT !");
      this.org_value = this.value // 나중에 items 가 업데이트 될 경우를 대비하여 원본 value 값 보관
      this.$emit('input', firstValue)

    },
    autoSelectByItems() { // items 변화에 따른 자동선택 ( 하아... 이런걸 왜 만들어야 하는지 ㅠ 뷰티파이 dog짜증 )

      isDebug && console.log("[i-input-sel] autoSelectByItems() : this.org_value =", this.org_value, "this.value =", this.value);

      if (this.value === undefined) { // 현재값이 undefined 면 일하지 않는다.
        isDebug && console.log("[i-input-sel] autoSelectByItems() : value is undefined. return")
        return
      }

      if (_.isEmpty(this.items_cp)) { // 배열이 없으면 자동선택 자체를 할게 없다.
        isDebug && console.log("[i-input-sel] autoSelectByItems() : items_cp is empty. return 1")
        return
      }

      if (this.value && this.hasItemsValue(this.value)) { // items가 변경되었더라도 이미 value가 있다면 아무것도 할 필요가 없다.
        isDebug && console.log("[i-input-sel] autoSelectByItems() : hasItemsValue. return 3")
        return
      }

      if (this.org_value && this.hasItemsValue(this.org_value)) { // 원본이 있고 변경된 items에 해당값이 있다면 그값을 사용하고 종료.
        this.$emit('input', this.org_value) // org_value를 사용한다
        this.org_value = null // 보관한건 이제 필요 없다.
        isDebug && console.log("[i-input-sel] autoSelectByItems() : use org_value. return 4")
        return
      }

      const firstValue = this.getFirstValue()
      isDebug && console.log("[i-input-sel] autoSelectByItems() : org_value가 list에 없다. firstValue로 설정 V = ", firstValue)
      this.org_value = this.value
      this.$emit('input', firstValue)
      return

    },
  },
}
</script>
